<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview" v-if="querytype == '按物料'">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{initData.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单位</label>
            <span class="weui-form-preview__value">{{initData.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{initData.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">来料总批数</label>
            <span class="weui-form-preview__value">{{initData.count}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">来料总数量</label>
            <span class="weui-form-preview__value">{{initData.qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">退货总数量</label>
            <span class="weui-form-preview__value">{{initData.thqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">合格批数</label>
            <span class="weui-form-preview__value">{{initData.okcount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不合格批数</label>
            <span class="weui-form-preview__value">{{initData.ngcount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">合格率%</label>
            <span class="weui-form-preview__value">{{initData.okrate}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview" v-else>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商</label>
            <span class="weui-form-preview__value">{{initData.qc_vendname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">来料总批数</label>
            <span class="weui-form-preview__value">{{initData.count}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">来料总数量</label>
            <span class="weui-form-preview__value">{{initData.qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">退货总数量</label>
            <span class="weui-form-preview__value">{{initData.thqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">合格批数</label>
            <span class="weui-form-preview__value">{{initData.okcount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不合格批数</label>
            <span class="weui-form-preview__value">{{initData.ngcount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">合格率%</label>
            <span class="weui-form-preview__value">{{initData.okrate}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object,
    querytype: String
  }
};
</script>